import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider, Typography } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import themes from 'themes';
import NavigationScroll from 'layout/NavigationScroll';
import { Grow } from '@mui/material';
import RouteNew from "routes/NewRoute";
import { Grid, } from '@mui/material';
import { NotificationManager } from 'react-notifications';

import useAuth from 'routes/Hooks/useAuth';
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { useNavigate } from 'react-router-dom';
import { fetchToken, onMessageListener, db } from './firebase';

import CompleteProfile from '../src/views/utilities/CompleteProfile'
import { MutatingDots } from 'react-loader-spinner'


const App = () => {

    const customization = useSelector((state) => state.customization);
    let { setAuth, auth } = useAuth()
    let navigation = useNavigate()
    let UserSessionId = localStorage.getItem("Uid")
    const [spinner, setSpinner] = useState(true);



    const [open, setOpen] = React.useState(false);
    const [notification, setNotification] = useState({ title: '', body: '' });
    const [isTokenFound, setTokenFound] = useState(false);

    fetchToken(setTokenFound);

    onMessageListener().then(payload => {
        setOpen(true);
        setNotification({ title: payload.notification.title, body: payload.notification.body })
        console.log('payload====>',payload)
        // NotificationManager.error(payload.notification.messages, 5000);
        NotificationManager.error(payload.notification.title, payload.notification.body, 5000, () => {
            // alert('callback');
          });

    }).catch(err => console.log('failed: ', err));


    const onShowNotificationClicked = () => {
        setNotification({ title: "Notification", body: "This is a test notification" })
        setOpen(true);
    }

    useEffect(() => {
        if (UserSessionId) {
            const unsub = onSnapshot(doc(db, "Users", UserSessionId), (doc) => {

                setAuth({ UserSessionId, User: doc.data() })

                navigation("/", { replace: true });
            })
        }
        setTimeout(() => setSpinner(false), 2000)

        function requestPermission() {
            console.log('Requesting permission...');
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    console.log('Notification permission granted.');
                }
            })
        }

    }, [])

    const UpdateToken = async () => {
        if (auth?.User != undefined) {
            const UpdateUser = doc(db, "Users", auth?.User?.uid);
            await updateDoc(UpdateUser, {
                WebToken: isTokenFound
            });
        }
    }


    useEffect(() => {
        UpdateToken()
    }, [isTokenFound,auth?.User?.uid])

    console.log('auth?.User',)


    return (
        <StyledEngineProvider injectFirst>


            <ThemeProvider theme={themes(customization)}>
                {spinner == true ?
                    <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}  >
                        <Grid item xs={12}>
                            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                                <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>

                                    <MutatingDots
                                        heigth="100"
                                        width="100"
                                        color='red'
                                        ariaLabel='loading'
                                        secondaryColor='red'
                                    />

                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>


                    :

                    <>
                        {auth?.User?.usertype == 'Student' && auth?.User?.ProfileReview != true ?
                            <CompleteProfile auth={auth} />

                            :

                            <SnackbarProvider maxSnack={5} anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
                                TransitionComponent={Grow}>
                                <CssBaseline />
                                <NavigationScroll>
                                    <RouteNew />

                                </NavigationScroll>
                            </SnackbarProvider>
                        }
                    </>
                }


            </ThemeProvider>

        </StyledEngineProvider>
    );
};

export default App;
